/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { CartItem, CartItemPayload } from '../storage/cart.types';

export const productToCartPayload = (product: CartItem): CartItemPayload => {
  return {
    productId: product.productId,
    quantity: product.quantity,
    unitPrice: product.basePriceExcGst,
    lineId: product.lineId ?? null,
  };
};
